import { Swiper, Navigation, Pagination } from 'swiper'

Swiper.use([Navigation, Pagination])

const google = window.google

const $locationSliderMap = document.querySelector('.location-slider-map')
const $map = document.getElementById('google-map')

const state = {
    map: null,
    currentMarkers: [],
    locations: [],
    mapCenter: null,
}

const fn = {
    init: () => {
        state.locations = JSON.parse($map.dataset.locations)
        state.mapCenter = new google.maps.LatLng(
            state.locations[0][0].lat,
            state.locations[0][0].lng
        )

        fn.setupMap()
    },

    setupMap: () => {
        const opts = {
            center: state.mapCenter,
            zoom: 17,
            maxZoom: 20,
            minZoom: 12,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            scrollwheel: false,
            styles: [
                {
                    featureType: 'administrative',
                    elementType: 'geometry',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'poi',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'transit',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
            ],
        }

        if (!fn.isMobile()) {
            opts.zoomControl = true

            opts.zoomControlOptions = {
                style: google.maps.ZoomControlStyle.LARGE,
                position: google.maps.ControlPosition.RIGHT_CENTER,
            }
        }

        state.map = new google.maps.Map($map, opts)

        google.maps.event.addListenerOnce(state.map, 'tilesloaded', () => {
            fn.placeMarkers()
            fn.setupSlider()
        })
    },

    setupSlider: () => {
        const $slider = $locationSliderMap.querySelector('.swiper-container')

        new Swiper($slider, {
            on: {
                slideChangeTransitionEnd: () => {
                    const $active = $slider.querySelector(
                        '.swiper-slide-active'
                    )

                    if ($active) {
                        const locations = fn.getLocationById(
                            parseInt($active.dataset.locationId)
                        )

                        fn.activateLocations(locations)
                    }
                },
            },
            autoHeight: true,
            loop: true,
            pagination: {
                el: $locationSliderMap.querySelector('.slider-pagination'),
                clickable: true,
            },
            navigation: {
                prevEl: $locationSliderMap.querySelector('.slider-prev'),
                nextEl: $locationSliderMap.querySelector('.slider-next'),
            },
        })
    },

    activateLocations: (locations) => {
        const bounds = new google.maps.LatLngBounds()

        state.currentMarkers.forEach((marker) => marker.setVisible(false))

        state.currentMarkers = locations.map((location) => location.marker)

        state.currentMarkers.forEach((marker) => {
            bounds.extend(marker.getPosition())

            return marker.setVisible(true)
        })

        state.map.fitBounds(bounds)

        if (state.currentMarkers.length < 2) {
            state.map.setZoom(17)
        }

        fn.panCenter(bounds.getCenter())
    },

    placeMarkers: () => {
        for (const locations of state.locations) {
            fn.setupMarker(locations)
        }

        fn.activateLocations(state.locations[0])
    },

    setupMarker: (locations) => {
        locations.forEach((location) => {
            const marker = new google.maps.Marker({
                map: state.map,
                title: location.label,
                position: new google.maps.LatLng(location.lat, location.lng),
                panposition: new google.maps.LatLng(location.lat, location.lng),
                icon: {
                    url: location.marker_url,
                    scaledSize: new google.maps.Size(75, 75),
                },
            })

            marker.setVisible(false)

            location.marker = marker

            google.maps.event.addListener(
                marker,
                fn.isMobile() ? 'touchend' : 'click',
                () => {
                    window.location.href = location.url
                }
            )
        })
    },

    panCenter: (latlng) => {
        let offsetX = 0
        const offsetY = 0

        if (window.matchMedia('(min-width: 768px)').matches) {
            offsetX = 180
        }

        if (
            window.matchMedia('(min-width: 1440px)').matches &&
            state.currentMarkers.length > 1
        ) {
            offsetX = 320
        }

        const point1 = state.map
            .getProjection()
            .fromLatLngToPoint(
                latlng instanceof google.maps.LatLng
                    ? latlng
                    : state.map.getCenter()
            )

        const point2 = new google.maps.Point(
            (typeof offsetX === 'number' ? offsetX : 0) /
                Math.pow(2, state.map.getZoom()) || 0,
            (typeof offsetY === 'number' ? offsetY : 0) /
                Math.pow(2, state.map.getZoom()) || 0
        )

        state.map.panTo(
            state.map
                .getProjection()
                .fromPointToLatLng(
                    new google.maps.Point(
                        point1.x - point2.x,
                        point1.y + point2.y
                    )
                )
        )
    },

    getLocationById: (id) => {
        return state.locations.find((location) =>
            location.find((x) => parseInt(x.id) === id && x.is_primary)
        )
    },

    isMobile: () => {
        return 'ontouchstart' in document.documentElement
    },
}

export default {
    can: () => $locationSliderMap,
    run: fn.init,
}
